module.exports = __webpack_public_path__ + "static/img/naturally.f767c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/naturally.png
// module id = urEZ
// module chunks = 4